// Storage keys
const STORAGE_KEYS = {
  IMAGES: 'imageflow_images',
  SETTINGS: 'imageflow_settings',
};

// Storage service for localStorage operations
export const storage = {
  // Get data from localStorage
  get: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error reading from localStorage: ${key}`, error);
      return null;
    }
  },

  // Set data to localStorage
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error(`Error writing to localStorage: ${key}`, error);
      return false;
    }
  },

  // Remove data from localStorage
  remove: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(`Error removing from localStorage: ${key}`, error);
      return false;
    }
  },

  // Clear all app data
  clear: () => {
    try {
      Object.values(STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
      return true;
    } catch (error) {
      console.error('Error clearing localStorage', error);
      return false;
    }
  },
};

// Image-specific storage operations
export const imageStorage = {
  // Get all stored images
  getImages: () => {
    return storage.get(STORAGE_KEYS.IMAGES) || [];
  },

  // Save images to storage
  saveImages: (images) => {
    // Only store user-uploaded images (not mock data)
    const userImages = images.filter(img => !img.id.startsWith('mock-'));
    return storage.set(STORAGE_KEYS.IMAGES, userImages);
  },

  // Add new images to storage
  addImages: (newImages) => {
    const existingImages = imageStorage.getImages();
    const updatedImages = [...newImages, ...existingImages];
    return storage.set(STORAGE_KEYS.IMAGES, updatedImages);
  },

  // Remove an image from storage
  removeImage: (imageId) => {
    const images = imageStorage.getImages();
    const updatedImages = images.filter(img => img.id !== imageId);
    return storage.set(STORAGE_KEYS.IMAGES, updatedImages);
  },

  // Clear all images
  clearImages: () => {
    return storage.remove(STORAGE_KEYS.IMAGES);
  },
};

export { STORAGE_KEYS };
